import Data from './Data';
import Menu from "./Menu";
import Header from "./Header";
import Carousel from "./Carousel";
import EmbedVideo from "./EmbedVideo";
import ReadMore from "./ReadMore";
import Frames from "./tileblock/animation/Frames";
import Form from "./Form";
import Field from "./Field";
import ImagesUploader from "./uploader/ImagesUploader";
import Upload from "./Upload";
import Confirm from "./Confirm";
import Hover from "./Hover";
import OstendeRegisterVenue from "./ostende/RegisterVenue";
import OstendeRegisterCompany from "./ostende/RegisterCompany";
import OstendeArtisticFieldsLabel from "./ostende/ArtisticFieldsLabel";
import OstendeEditDirectoryCard from "./ostende/EditDirectoryCard";
import OstendePerformanceForm from "./ostende/PerformanceForm";
import OstendeVenuesAutocomplete from "./ostende/VenuesAutocomplete";
import OstendeCompanyAgenda from "./ostende/agenda/CompanyAgenda";
import OstendeAgenda from "./ostende/agenda/Agenda";
import OstendeJobOffers from "./ostende/jobs/JobOffers";
import OstendeEditJobOffer from "./ostende/jobs/EditJobOffer";
import OstendeJobOfferItem from "./ostende/jobs/JobOfferItem";
import OstendeRoomAvailabilities from "./ostende/room-availabilities/RoomAvailabilities";
import EditableList from "./EditableList";
import CursusFeedbackForm from "./cursus/FeedbackForm";
import SizeObserver from "./SizeObserver";
import PostalCodeCity from "./ekip/PostalCodeCity";
import LexiconDefinition from "./LexiconDefinition";
import BreadcrumbDropdown from "./BreadcrumbDropdown";
import BreadcrumbDropdownToggle from "./BreadcrumbDropdownToggle";
import ReadMoreLineclamp from "./ReadMoreLineclamp";


export default {
    'v-data': Data,
    'aca-menu': Menu,
    'aca-header': Header,
    'aca-carousel': Carousel,
    'aca-embed-video': EmbedVideo,
    'aca-read-more': ReadMore,
    'aca-read-more-lineclamp': ReadMoreLineclamp,
    'aca-frames': Frames,
    'aca-form': Form,
    'aca-field': Field,
    'aca-images-uploader': ImagesUploader,
    'aca-upload': Upload,
    'aca-confirm': Confirm,
    'aca-hover': Hover,
    'aca-breadcrumb-dropdown': BreadcrumbDropdown,
    'aca-breadcrumb-dropdown-toggle': BreadcrumbDropdownToggle,
    'aca-lexicon-definition': LexiconDefinition,
    OstendeRegisterVenue,
    OstendeRegisterCompany,
    OstendeArtisticFieldsLabel,
    OstendeEditDirectoryCard,
    OstendePerformanceForm,
    OstendeVenuesAutocomplete,
    OstendeCompanyAgenda,
    OstendeAgenda,
    OstendeJobOffers,
    OstendeEditJobOffer,
    OstendeJobOfferItem,
    OstendeRoomAvailabilities,
    OstendeSearch: () => ({
        component: import(/* webpackChunkName: 'ostende-search', webpackPreload: true */'./ostende/search/Search.vue'),
        loading: { functional: true, render: (h, ctx) => ctx.scopedSlots.default() },
    }),
    EditableList,
    CursusFeedbackForm,
    'size-observer': SizeObserver,
    'postal-code-city': PostalCodeCity,
}
